/**
 * ChartTypeToggle — Toggle between candlestick and line chart modes.
 *
 * Story 4.3 — Task 4
 */

import { cn } from "../../lib/cn";

export type ChartType = "candlestick" | "line";

type ChartTypeToggleProps = {
	selected: ChartType;
	onChartTypeChange: (type: ChartType) => void;
};

export function ChartTypeToggle({ selected, onChartTypeChange }: ChartTypeToggleProps) {
	return (
		<div className="flex gap-1" aria-label="Chart type">
			<button
				type="button"
				aria-pressed={selected === "candlestick"}
				aria-label="Candlestick chart"
				onClick={() => onChartTypeChange("candlestick")}
				className={cn(
					"inline-flex items-center justify-center h-8 w-8 rounded-lg transition-colors",
					selected === "candlestick"
						? "bg-pastel-vibrant-blue text-white"
						: "text-pastel-gray hover:bg-pastel-light-gray"
				)}
			>
				<svg viewBox="0 0 16 16" fill="currentColor" className="h-4 w-4" aria-hidden="true">
					<rect x="3" y="2" width="2" height="12" rx="0.5" />
					<rect x="7" y="5" width="2" height="6" rx="0.5" />
					<rect x="11" y="3" width="2" height="10" rx="0.5" />
				</svg>
			</button>
			<button
				type="button"
				aria-pressed={selected === "line"}
				aria-label="Line chart"
				onClick={() => onChartTypeChange("line")}
				className={cn(
					"inline-flex items-center justify-center h-8 w-8 rounded-lg transition-colors",
					selected === "line"
						? "bg-pastel-vibrant-blue text-white"
						: "text-pastel-gray hover:bg-pastel-light-gray"
				)}
			>
				<svg
					viewBox="0 0 16 16"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
					className="h-4 w-4"
					aria-hidden="true"
				>
					<polyline points="1,12 5,6 9,9 15,3" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</button>
		</div>
	);
}
